<template>
  <FiltersSlideOutContent
    :value="localValue"
    :dimensions="filterableDimensions"
    :useSalesInsightsIfAvailable="useSalesInsightsIfAvailable"
    @input="handleInput"
  ></FiltersSlideOutContent>
</template>
<script>
import { isBaseFilter } from '../../../../services/dashboard/filtersService';
import FiltersSlideOutContent from '../../Common/FiltersSlideOutContent.vue';

export default {
  props: {
    value: {
      type: Array,
    },
    dimensions: {
      type: Array,
    },
    useSalesInsightsIfAvailable: {
      type: Boolean,
    },
  },
  components: {
    FiltersSlideOutContent,
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  computed: {
    filterableDimensions() {
      return this.dimensions.filter(isBaseFilter);
    },
  },
  methods: {
    handleInput(val) {
      this.localValue = val;

      this.$emit('input', this.localValue);
    },
  },
  watch: {
    value() {
      this.localValue = this.value;
    },
  },
};
</script>
